define('SC.GlobalConfigurationEntryPoint', [
    'SC.GlobalConfiguration.1.0.0.GlobalConfiguration',
    'SC.HideQuantityPricing.1.0.0.HideQuantityPricing'
], function CustomerSegmentsShoppingEntryPoint(
    GlobalConfiguration,
    HideQuantityPricing
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            GlobalConfiguration.mountToApp(application);
            HideQuantityPricing.mountToApp(application);
        }
    };
});
